import React, { RefObject, useEffect, useState } from "react";
import axios from "axios";

export function SearchBox({
  token,
  onChange,
  ref
}: {
  token: string;
  onChange?: (mapData: any) => void;
  ref:RefObject<any>
}) {
  const [data, setData] = useState<any>();
  const [selected, setSelected] = useState<any>();
  const fetchDate = async (word: string) => {
    const url = `https://api.mapbox.com/geocoding/v5/mapbox.places/${word}.json?country=MM&access_token=${token}`;
    await axios
      .get(url, {
        headers: {
          "User-Agent":
            "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/91.0.4472.124 Safari/537.36",
        },
      })
      .then(({ data }) => {
        setData(data);
      })
      .catch((err) => {
        throw err;
      });
  };
  const handleChange = (word: string) => {
    if (word && word !== "" && word !== " ") {
      fetchDate(word);
    }
  };
  useEffect(() => {
    onChange && onChange(selected);
  }, [selected]);
  return (
    <div>
      <input
        onChange={(e) => handleChange(e.target.value)}
        placeholder="Search"
      />
      <div style={{ position: "absolute" }}>
        {data?.features.map((place: any) => (
          <div key={place.id} onClick={() => {
            setSelected(place);
            ref?.current?.flyTo({
              center: place.center,
              zoom: 13,
            });
          }}>{place.place_name}</div>
        ))}
      </div>
    </div>
  );
}
